import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import QualysWebappConfigListing from './QualysWebappConfigListing'
import QualysWebappCredentialsForm from './QualysWebappCredentialsForm'

export default function QualysWebappPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={QualysWebappCredentialsForm}
            PullConfigListingView={QualysWebappConfigListing}
        />
    )
}